// @flow
import React from "react";
import { useDispatch } from "react-redux";
import { clearGlobalFilterReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import { primaryColor } from "../../../../utility/constants/colorManager";
import { CustomLoader } from "../custom_loader";

export const CustomButton = ({
  title,
  onClick,
  loading,
  disabled = false,
  styles,
  textStyles,
  backgroundColor = primaryColor,
  hoverColor,
  hoverTextColor,
  textColor,
  size = "medium",
  isBorderRequiredOnHover = true,
  loginButton,
  dataTestId = "button",
  icon,
  ionDirection = "left",
  mobileViewBtn,
  showChecked = false,
  borderColor
}) => {
  const dispatch = useDispatch();
  return (
    <button
      data-testid={dataTestId}
      style={{
        backgroundColor: disabled
          ? "lightgrey"
          : backgroundColor
            ? backgroundColor
            : "black",
        borderRadius: 5,
        alignSelf: "center",
        padding: 6,
        cursor: "pointer",
        // minWidth: loginButton ? 304 : 80,
        border: `1px solid ${disabled ? "lightgrey" : backgroundColor || borderColor}`,
        outline: "none",
        height: 40,
        // width: mobileViewBtn ? 120 : 150,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px 15px",
        position: "relative",
        ...styles,
      }}
      disabled={loading || disabled ? true : false}
      onClick={onClick}
    >
      {showChecked && (
        <div
          style={{
            width: 13,
            height: 13,
            borderRadius: "50%",
            backgroundColor: "red",
            top: -5,
            position: "absolute",
            right: -5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontSize: 10,
          }}
        // onClick={() => {
        //   dispatch(clearGlobalFilterReducer());
        // }}
        ></div>
      )}
      <div
        style={{
          marginLeft: 5,
          alignSelf: "center",
          marginRight: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        {ionDirection === "left" && (
          <div
            style={{
              marginRight: 5,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {icon && icon}
          </div>
        )}
        {loading ? (
          <CustomLoader />
        ) : (
          <p
            style={{
              fontSize: mobileViewBtn ? 12 : 13,
              cursor: "pointer",
              fontWeight: "500",
              color: textColor ? textColor : disabled ? "grey" : "white",
              padding: 0,
              margin: 0,
              alignSelf: "center",
              cursor: disabled ? "not-allowed" : "pointer",
              ...textStyles,
            }}
            className="latoRegular"
          >
            {title}
          </p>
        )}
        {ionDirection === "right" && (
          <div
            style={{
              marginLeft: 5,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            {icon && icon}{" "}
          </div>
        )}
      </div>
    </button>
  );
};
